

<div class="directionLtr" style="padding: 0 15px 15px;">
    <div class="directionLtr" id="{{chartId}}" [style.width.%]="100" [style.height.px]="300"></div>
</div>